export default __webpack_public_path__ + "static/media/ceo.53218ca4.jpg";